module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "discover flex flex-column flex-1"
  }, [_c('u-header', {
    attrs: {
      "show-back": ""
    }
  }, [_vm._v("忘记密码")]), _vm._v(" "), _c('div', {
    staticClass: "scrollable container flex-1 flex flex-row"
  }, [_c('form', {
    staticClass: "flex-1",
    attrs: {
      "name": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.forget($event)
      }
    }
  }, [_c('u-input', {
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "请输入您的邮箱",
      "autofocus": "",
      "tabindex": "1"
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }, [(_vm.submitted && _vm.validation.hasError('email')) ? _c('span', {
    staticClass: "input-error",
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_vm._v(_vm._s(_vm.validation.firstError('email')))]) : _vm._e()]), _vm._v(" "), _c('u-button', {
    staticStyle: {
      "margin-top": "40px"
    },
    attrs: {
      "native-type": "submit"
    }
  }, [_vm._v("重置密码")])], 1), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_vm._v("如果您没有绑定邮箱，请联系管理员来重置密码")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6be5eab4","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/auth/ForgetPassword.vue
// module id = 268
// module chunks = 8